<template>
	<section class="Payment">
		<h2>お支払い方法を選択：</h2>
		<Form :data="methodFormData" :form="methodForm" @change="onMethodFormChange" data-form="method" />
		<hr />
		<Form
			v-if="method === 'creditcard'"
			:data="creditcardFormData"
			:form="creditcardForm"
			@change="onCreditcardFormChange"
			data-form="creditcard"
		/>
		<Button :disabled="buttonDisabled" class="confirm" @click="onClickPay">お支払いを確定する</Button>
	</section>
</template>

<script>
	export default {
		props: {
			methods: {
				default: () => ['creditcard', 'linepay', 'paypal']
			}
		},
		data() {
			return {
				method: 'creditcard',
				creditcard: {
					name: '',
					number: ['', '', '', ''],
					expires: ['', ''],
					cvv: ''
				},

				methodForm: [
					{
						type: 'checkbox',
						name: 'method',
						multiselect: false,
						options: [
							{ label: 'クレジットカード', value: 'creditcard' },
							{ label: 'LINE PAY', value: 'linepay' },
							{ label: 'Paypal', value: 'paypal' }
						].filter(option => this.methods.some(method => option.value === method))
					}
				],
				creditcardForm: [
					{
						name: 'name',
						label: 'カード名義',
						placeholder: 'SHIHARAI TARO'
					},
					{
						name: 'number',
						label: 'カード番号',
						maxlength: 4,
						placeholder: ['1234', '1234', '1234', '1234']
					},
					{
						name: 'expires',
						label: '有効期限',
						placeholder: ['MM', 'YY'],
						maxlength: 2
					},
					{
						name: 'cvv',
						label: 'CVV',
						maxlength: 3,
						placeholder: '000'
					}
				]
			};
		},

		computed: {
			methodFormData() {
				return {
					method: this.method
				};
			},
			creditcardFormData() {
				return {
					...this.creditcard
				};
			},
			buttonDisabled() {
				return !(
					this.method !== 'creditcard' ||
					(this.creditcard.name &&
						this.creditcard.cvv.length === 3 &&
						this.creditcard.number.every(e => e.length === 4) &&
						this.creditcard.expires.every(e => e.length === 2))
				);
			}
		},

		methods: {
			onMethodFormChange(key, value) {
				this.method = value;
			},
			onCreditcardFormChange(key, value) {
				this.creditcard[key] = value;
			},
			onClickPay() {
				const payload = {
					method: this.method
				};

				if (this.method === 'creditcard') {
					payload.data = { ...this.creditcard };
				}

				this.$emit('pay', payload);
			}
		}
	};
</script>

<style scoped lang="scss">
	.Payment {
		padding: 1.6rem;
		max-width: 48rem;

		h2 {
			font-size: 1.6rem;
			font-weight: normal;
		}

		hr {
			border: none;
			border-top: dashed 1px rgba(0, 0, 0, 0.2);
			display: block;
		}

		& > * {
			&:not(:first-child) {
				margin-top: 2rem;
			}
		}

		/deep/ .Form {
			&[data-form='method'] {
				.form-group {
					.input-area {
						display: flex;
						flex-direction: column;

						.checkbox {
							margin-right: 0.5rem;
							&:not(:first-child) {
								margin-top: 1.6rem;
							}

							&::after {
								font-family: 'icomoon';
								margin-left: 4rem;
								font-size: 1.5em;
							}

							&[for*='creditcard'] {
								&::after {
									content: '\e934';
									color: var(--clrTheme);
								}
							}

							&[for*='linepay'] {
								&::after {
									content: '\e90e';
									color: #00c300;
								}
							}

							&[for*='paypal'] {
								&::after {
									content: '\e935';
									color: #00457c;
								}
							}
						}
					}
				}
			}

			&[data-form='creditcard'] {
				.form-group {
					&[data-entry='name'],
					&[data-entry='number'] {
						flex: 0 1 100%;
					}

					&[data-entry='number'],
					&[data-entry='expires'] {
						display: flex;
						flex-direction: row;
						flex-wrap: wrap;
						align-items: center;
						margin-bottom: -0.5rem;

						.title {
							flex: 0 1 100%;
							margin-bottom: -0.5rem;
						}

						.input-area {
							margin: 0.5rem 0;
							flex: 1 0 8rem;

							input {
								text-align: center;
							}
						}

						.separator {
							margin: 0 1rem;
							&::before {
								content: '-';
							}
						}
					}

					&[data-entry='number'] {
						.input-group {
							display: flex;

							@include phone {
								flex-wrap: wrap;

								.input-area {
									flex: 1 0 40%;

									&:nth-of-type(2n) {
										margin-left: 1rem;
									}
								}

								.separator {
									display: none;
								}
							}
						}
					}

					&[data-entry='expires'] {
						flex: 0 1 16rem;
						margin-right: 2rem;

						.separator {
							&::before {
								content: '/';
							}
						}

						.input-area {
							flex: 1 0 4rem;
						}
					}

					&[data-entry='cvv'] {
						flex: 0 1 8rem;
						.input-area {
							input {
								text-align: center;
							}
						}
					}
				}
			}
		}

		.confirm {
			width: 100%;
		}
	}
</style>
